import React, { useState, useEffect, useRef } from "react"
import { useLocation } from "@reach/router"
import dateFormat from 'dateformat';
import $ from 'jquery';

import { Form, Modal, Row, Spinner } from "react-bootstrap"

import { getUser } from "@starberry/myaccount-website-utils"

import InputField from 'gatsby-theme-starberry-lomondgroup/src/components/forms/elements/input'
import SelectField from 'gatsby-theme-starberry-lomondgroup/src/components/forms/elements/select'
import TextAreaField from 'gatsby-theme-starberry-lomondgroup/src/components/forms/elements/textarea'
import CheckboxField from 'gatsby-theme-starberry-lomondgroup/src/components/forms/elements/checkbox'
import RadioboxField from 'gatsby-theme-starberry-lomondgroup/src/components/forms/elements/radio'
import ButtonField from 'gatsby-theme-starberry-lomondgroup/src/components/forms/elements/button'
import HtmlBox from 'gatsby-theme-starberry-lomondgroup/src/components/forms/elements/html'
import ReCaptchaBox from 'gatsby-theme-starberry-lomondgroup/src/components/forms/elements/recaptcha'
import PostcodeField from 'gatsby-theme-starberry-lomondgroup/src/components/forms/elements/postcode'
// import FormLoadingOverlay from "../FormLoadingOverlay/FormLoadingOverlay"
import 'gatsby-theme-starberry-lomondgroup/src/components/forms/assets/styles/_index.scss'
import { postFormData, api_form_error } from "gatsby-theme-starberry-lomondgroup/src/components/forms/api/Api"
import { FormsSubject } from "gatsby-theme-starberry-lomondgroup/src/common/form-mail-subjects"
import { phoneNumberValidation, isValidPhone, Mail_Function, getUrlParams, toCapitalize } from "gatsby-theme-starberry-lomondgroup/src/common/utils/site_utlis"
import { OfficeList } from "gatsby-theme-starberry-lomondgroup/src/common/queries/common_use_query"
import { marketing_consent } from "gatsby-theme-starberry-lomondgroup/src/common/constant"
import { PageLinks } from "../../common/page-links";


function ContactForm(props) {
  const { loading, error, data } = OfficeList();

  const location = useLocation();
  const userData = getUser();

  const [validated, setValidated] = useState(false);
  const [showerror, setShowerror] = useState(false);
  const [showerrormsg, setShowerrorMsg] = useState("");
  const [showthankyou, setThankyou] = useState(false);
  const [startDate, setStartDate] = useState();
  const [startTime, setStartTime] = useState();

  const [formvalues, setFormvalues] = useState("");

  const [token, setToken] = useState("");

  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectError, setSelectError] = useState(false);

  const [postcode, setPostcode] = useState("");
  const [address, setAddress] = useState("");
  const [postCodeError, setPostCodeError] = useState(false);
  const [postCodeAddress, setPostCodeAddress] = useState(true);
  const [postcodeInlineError, setPostcodeInlineError] = useState("");
  const [postcodeResetKey, setPostcodeResetKey] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const myRef = React.createRef();

  const recaptchaRef = React.createRef();

  const formRef = useRef(null);

  const selectHandelChange = (name, value) => {
    setPostcode(value);
    setPostCodeAddress(true)
  }

  const postcodeChange = (suggestion) => {
    setPostcode(suggestion.postcode)
    var line1 = suggestion.line_1 || suggestion.line1;
    var line2 = suggestion.line_2 || suggestion.line2;
    var line3 = suggestion.line_3 || suggestion.line3;
    var town = suggestion.post_town || suggestion.town;
    var selected_address = line1 ? line1 : "";
    selected_address += line2 ? ", "+line2 : "";
    selected_address += line3 ? ", "+line3 : "";
    selected_address += selected_address.trim() ? (town ? ", "+town : "") : (town ? town : "");

    setAddress(`${toCapitalize(selected_address)}`)

    setPostCodeAddress(false);
    setPostcodeInlineError("");
    $(".postcode-field-wrapper .form-control").removeClass("is-invalid");
  }

  var branch_list = [];

  if (data && data.offices && data.offices.length > 0) {
    data.offices.map((item, index) => {
      branch_list.push({label:item.name, value:item.name+","+item.email});
    })
  }

  var best_interest = ["Existing UK landlord", "Existing UK property investor", "Looking to buy UK property", "Property professional", "Other"]

  var to_email_id = location?.state?.to_email_id ? location?.state?.to_email_id : props.to_email_id ? props.to_email_id : "";

  var replace_slashes = location.pathname.replace(/\//g, '');

  const isInternationContact = props.title === "International Contact Form" ? true : false

  const notShowBranch = isInternationContact || props.title === "Contact Student Team" || props.title === "Seminar Form" || props.title === "Contact Landlord" ? true : false

  const isSeminarForm = props.title === "Seminar Form" ? true : false

  //console.log("location ==>", location, replace_slashes, props.title);

  let user_subject = FormsSubject.get_in_touch.user_subject
  let admin_subject = FormsSubject.get_in_touch.admin_subject

  if(isSeminarForm){
    user_subject = "Seminar confirmation"
    admin_subject = "Seminar confirmation"
  }
  if(props.title === "Contact Landlord"){
    admin_subject = "Contact Landlord"
  }


  var fields = ([
    {
      element: "config",
      formname: props.title ? props.title : "General Enquiry",
      form_type: props.title ? props.title : "General Enquiry",
      error_text: "Highlighted fields are required.",
      success_text: "Thank you, a member of our team will be in contact soon.",
      email_temp_user: isSeminarForm ? "seminar_form_user" : "contact_user",
      email_temp_admin: isSeminarForm ? "seminar_form_admin" : "contact_admin",
      email_server_func: "general-enquiry",
      event_tracking: "general-enquiry",
      page_url: location.href,
      email_subject_user: user_subject,
      email_subject_admin: admin_subject
    },
  ])

  if(notShowBranch){

  } else{
    fields.push(
      {
        grpmd: "12",
        label: "Select Branch",
        name: "branch",
        element: "select",
        required: true,
        values: branch_list,
        divclass: "form-wrap",
        labelClass: "annual-txt",
        class: "full_wdth_box",
        optionWithLabel: true,
      },
    )
  }

  fields.push(
    {
      grpmd: "6",
      label: "First Name",
      placeholder: "",
      name: "first_name",
      type: "text",
      element: "input",
      required: true,
      patternchk: "^[a-zA-Z][a-zA-Z '.\\-]*$",
      labelClass: "annual-txt",
      errorMsg: "Enter a valid first name",
      maxlengthSoft: 50,
      divclass: "form-wrap",
      defaultValue: userData?.name || ``
    },
    {
      grpmd: "6",
      label: "Last Name",
      placeholder: "",
      name: "last_name",
      type: "text",
      element: "input",
      required: true,
      patternchk: "^[a-zA-Z][a-zA-Z '.\\-]*$",
      labelClass: "annual-txt",
      errorMsg: "Enter a valid last name",
      maxlengthSoft: 50,
      divclass: "form-wrap",
    },
    {
      grpmd: "6",
      label: "Email Address",
      placeholder: "",
      name: "email",
      type: "email",
      element: "input",
      required: true,
      patternchk: "[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$",
      labelClass: "annual-txt",
      errorMsg: "Enter a valid email id",
      divclass: "form-wrap",
      defaultValue: userData?.email || ``
    },
    {
      grpmd: "6",
      label: "Phone Number",
      placeholder: "",
      name: "telephone",
      type: "text",
      element: "input",
      required: true,
      patternchk: "^[+]*[0-9\\-\\(\\)]+(\\s+[0-9\\-\\(\\)]+)*.{9,}$",
      labelClass: "annual-txt",
      errorMsg: "Enter a valid phone number",
      divclass: "form-wrap",
      defaultValue: userData?.mobile || ``
    },
  );

  if (props.leadpro_lead_type) {
    fields.push(
      {
        grpmd: "12",
        label: "Your property address",
        placeholder: "Enter your postcode",
        name: "postcode",
        type: "text",
        element: "postcode",
        required: true,
        labelClass: "annual-txt",
        errorMsg: "Enter a valid postcode.",
        divclass: "form-wrap"
      },
    )
  }

  if(isSeminarForm){
    fields.push(
      {
        grpmd: "6",
        label: "Which best describes your interest?",
        name: "best_interest",
        element: "select",
        required: true,
        values: best_interest,
        divclass: "form-wrap",
        labelClass: "annual-txt",
        class: "",
        optionWithLabel: false
      },
      {
        grpmd: "6",
        label: "Number of Attendees",
        placeholder: "",
        name: "noof_attendees",
        type: "text",
        element: "input",
        required: true,
        labelClass: "annual-txt",
        //errorMsg: "Alphanumeric and special characters (-_.) are only allowed.",
        divclass: "form-wrap",
      },
      {
        grpmd: "12",
        label: "Day of attendance",
        name: "day_attendance",
        element: "select",
        required: true,
        values: ["Sunday 4th October"],
        divclass: "form-wrap",
        labelClass: "annual-txt",
        class: "",
        optionWithLabel: false
      },
    )
  } else{
    fields.push(
      {
        grpmd: "12",
        label: "Message",
        placeholder: "Write your message here...",
        name: "message",
        element: "textarea",
        class: "",
        required: true,
        rows: "4",
        labelClass: "annual-txt",
        errorMsg: "Enter the enquiry message.",
        divclass: "form-wrap",
      }
    )
  }

  if (props.leadpro_lead_type) {
    fields.push(
      {
        grpmd: "12",
        label: marketing_consent,
        placeholder: marketing_consent,
        name: "gdpr_checkbox",
        type: "checkbox",
        element: "checkbox",
        required: false,
        value: true,
        labelClass: "",
        class: "checkbox_cnt gdpr_checkbox",
        divclass: "form-wrap",
      },
    )
  }

  fields.push(
    {
      grpmd: "12",
      name: "SUBMIT",
      type: "submit",
      element: "button",
      value: "Submit",
      class: "btn btn-green",
      labelClass: "",
      customClass: "custom-button-wrapper mt-4",
      divclass: "form-wrap"
    },
    {
      text: 'By proceeding, you agree to the terms set out in our <a href="/' + PageLinks.privacy_policy + '/">Privacy Policy.</a>',
      element: "html",
      class: "mt-3 text-center content_r-m"
    },
    {
      element: "captcha",
      class: "py-2",
      captchaRef: recaptchaRef
    },
  );

  const handlechange = event => {
    // remove initial empty spaces

    if (event.type === "select") {
      //event.value = event.value.trimStart()

      setSelectedOptions(prev => ({
        ...prev,
        [event.name]: event
      }));
    } else {
      if (event.target.name === "telephone") {
        var valid_phone = phoneNumberValidation(event.target.value);
        if (valid_phone) {
          event.target.value = valid_phone;
          event.target.setCustomValidity(isValidPhone(valid_phone) ? "" : "Enter a valid phone number");
        } else {
          event.target.value = '';
        }
      } else {
        event.target.value = event.target.value.trimStart()
      }
    }

  }

  useEffect(() => {

    //console.log("token", token); 

    if (token !== '') {

      const processFromData = async () => {

        let formData = new FormData();

        formData.append('data', JSON.stringify(formvalues));
        setShowerror(false);

        

        postFormData(formData).then(async apiRes => {

          //console.log("apiRes", apiRes);

          window.grecaptcha.reset();

          if (apiRes?.success === true) {
            // tracking event
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'formSubmit',
              'formType': 'form-' + fields[0].event_tracking,
              'formId': 'form-' + fields[0].event_tracking,
              'formName': fields[0].formname,
              'formLabel': fields[0].formname
            });


            setThankyou(true);
            // setTimeout(() => {
            //   setThankyou(false)
            // }, 6000);

            await Mail_Function(formvalues);

            // clear the form only after a confirmed successful submission
            if (formRef.current) {
              formRef.current.reset();
            }
            setStartDate();
            setStartTime();
            setPostcode("");
            setAddress("");
            setPostCodeError(false);
            setPostCodeAddress(true);
            setPostcodeInlineError("");
            setPostcodeResetKey(prev => prev + 1);

          } else {
            setShowerror(true);
            setThankyou(false);
            setShowerrorMsg(api_form_error)
          }

          setToken("");
          setIsSubmitting(false);

        });

        formvalues['g-recaptcha-response'] = token;

        myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' })

      }


      processFromData();

    }
  }, [token]);

  const handleonVerify = token => {
    console.log("captcha verified");
    setToken(token);
  };

  const handleSubmit = event => {

    const form = event.currentTarget;

    //console.log("event =>", form);

    var form_obj_arr = Object.entries(form);

    //console.log("form_obj_arr =>", form_obj_arr.filter(item => item[1].required === true));

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setShowerror(true);
      setValidated(true);
      setThankyou(false);
      setShowerrorMsg(fields[0].error_text)

      const requiredSelects = fields.filter(f => f.element === "select" && f.required);
      const hasMissingSelect = requiredSelects.some(f => !selectedOptions?.[f.name]?.value);
      setSelectError(hasMissingSelect);

      if (props.leadpro_lead_type) {
        if (postCodeError || !postcode) {
          setPostcodeInlineError("Enter a valid postcode");
        } else if (postCodeAddress) {
          setPostcodeInlineError("Select a valid postcode address.");
        } else {
          setPostcodeInlineError("");
        }
      }

      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
    else {

      event.preventDefault();

      if (props.leadpro_lead_type && postCodeError) {
        setShowerror(true);
        setThankyou(false);
        setShowerrorMsg("Enter a valid postcode.");
        setPostcodeInlineError("Enter a valid postcode");
        $(".postcode-field-wrapper .form-control").addClass("is-invalid");
        myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
        return;
      } else if (props.leadpro_lead_type && postCodeAddress) {
        setShowerror(true);
        setThankyou(false);
        setShowerrorMsg("Select a valid postcode address.");
        setPostcodeInlineError("Select a valid postcode address.");
        $(".postcode-field-wrapper .form-control").addClass("is-invalid");
        myRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
        return;
      }

      setPostcodeInlineError("");
      $(".postcode-field-wrapper .form-control").removeClass("is-invalid");

      const formsdata = (event.target);

      const json = {}
      Object.keys(formsdata).map(key => {

        if (formsdata[key].type === "checkbox") {
          if (formsdata[key].checked === true) {
            json[formsdata[key].name] = 'yes'
          }
        } else if (formsdata[key].type === "radio") {
          if (formsdata[key].checked === true) {
            json[formsdata[key].name] = formsdata[key].value
          }
        } else {
          json[formsdata[key].name] = formsdata[key].value
        }

      })

      var date_time = dateFormat(startDate, "mmm dd, yyyy") + " " + dateFormat(startTime, "hh:MM TT");
      json['name'] = json.first_name+' '+json.last_name;
      var params = getUrlParams();
      //console.log("filtered_team", params);

      var branch_split = json.branch ? json.branch.split(',') : "";

      json['email_temp_user'] = fields[0].email_temp_user;
      json['email_temp_admin'] = fields[0].email_temp_admin;
      json['email_subject_user'] = fields[0].email_subject_user;
      json['email_subject_admin'] = fields[0].email_subject_admin;
      json['formname'] = fields[0].formname;
      json['g-recaptcha-response'] = token;
      json['date_time'] = date_time;
      json['branch'] = branch_split.length > 0 ? branch_split[0] : json.branch;
      if (branch_split.length > 0) {
        json['to_email_id'] = branch_split[1];
      }

      if(isInternationContact){
        json['international'] = true
      }

      if(props.leadpro_lead_type){
        json['extra'] = { address: address };
      }


      //console.log("formsdata_json", json);

      setFormvalues(json);
      setIsSubmitting(true);
      if(process.env.GATSBY_CAPTCHA_MODE === "test"){
        setToken("test");
      } else{
        recaptchaRef.current.execute();
      }

      setValidated(false);
      setSelectError(false);
      setSelectedOptions({});

    }
  };

  //console.log("selectedOptions", selectedOptions);

  return (
    <div className="form" style={{ position: "relative" }}>

      {/* <FormLoadingOverlay isLoading={isSubmitting} /> */}

      {showerror && <div className="alert alert-danger">
        {showerrormsg}
      </div>}
      <div ref={myRef}></div>

      {showthankyou && !isSeminarForm && <div className="alert alert-success">
        {fields[0].success_text}
      </div>}

      {isSeminarForm && (
        <Modal
          show={showthankyou}
          onHide={() => setThankyou(false)}
          centered
          aria-labelledby="seminar-form-success-title"
          className="modal_bg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="seminar-form-success-title">
              Form Submitted Successfully!
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="mb-0">{fields[0].success_text}</p>
          </Modal.Body>
        </Modal>
      )}


      <Form ref={formRef} name={fields[0].formname} className={props.classNames} action="/" method="post" noValidate validated={validated} onSubmit={handleSubmit} autoComplete="off">

        <input type="hidden" name="form_name" value={(isInternationContact || props.leadpro_lead_type) ? "leadpro-valuation" : fields[0].formname} />
        <input type="hidden" name="ma_formname" value={fields[0].form_type} />

        <input type="hidden" name="form_type" value={fields[0].form_type} />
        <input type="hidden" name="form_label" value={fields[0].formname} />
        <input type="hidden" name="to_email_id" value={to_email_id} />
        <input type="hidden" name="admin_email" value={props.leadpro_lead_type ? "No" : "Yes"} />

        {isInternationContact &&
        <>
          {/* <input type="hidden" name="international" value={isInternationContact} /> */}
          <input type="hidden" name="lead_type" value={"leads"} />
          <input type="hidden" name="postcode" value={"E14"} />
          <input type="hidden" name="address" value={'London'} />
          <input type="hidden" name="type" value={'landlord'} />
          <input type="hidden" name="search_type" value={'landlord'} />
        </>
        }

        {props.leadpro_lead_type &&
        <>
          <input type="hidden" name="lead_type" value={"leads"} />
          <input type="hidden" name="type" value={props.leadpro_lead_type} />
          <input type="hidden" name="search_type" value={props.leadpro_lead_type} />
          <input type="hidden" name="postcode" value={postcode} />
          <input type="hidden" name="address" value={address} />
        </>
        }

        <input type="hidden" name="bot-field" />

        <input type="hidden" name="banner" value={props?.banner_image} />

        <Row className="custom-text-field-wrapper no_direction">
          {fields.map((field, index) => {
            if ("input" === field.element) {
              return (
                <InputField
                  name={field.name}
                  divclass={field.divclass}
                  grpmd={field.grpmd}
                  label={field.label}
                  ref={field.ref}
                  type={field.type}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  labelClass={field.labelClass}
                  required={field.required}
                  key={`${field.element}~${index}`}
                  pattern={field.patternchk}
                  handlechange={handlechange}
                  errorMsg={field.errorMsg}
                  showErrorMsg={true}
                  maxlengthSoft={field?.maxlengthSoft}
                  startDate={field.type === 'valuation_date' ? startDate : ''}
                  setStartDate={field.type === 'valuation_date' ? setStartDate : ''}
                  startTime={field.type === 'valuation_time' ? startTime : ''}
                  setStartTime={field.type === 'valuation_time' ? setStartTime : ''}
                  defaultValue={field?.defaultValue}
                />
              );
            }
            if ("postcode" === field.element) {
              return (
                <PostcodeField
                  name={field.name}
                  divclass={field.divclass}
                  grpmd={field.grpmd}
                  label={field.label}
                  ref={field.ref}
                  type={field.type}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  labelClass={field.labelClass}
                  required={field.required}
                  key={`${field.element}~${index}~${postcodeResetKey}`}
                  pattern={field.patternchk}
                  handlechange={handlechange}
                  errorMsg={field.errorMsg}
                  showErrorMsg={true}
                  inlineErrorMsg={postcodeInlineError}
                  selectHandelChange={selectHandelChange}
                  postcodeChange={postcodeChange}
                  setPostCodeError={setPostCodeError}
                />
              );
            }
            if ("select" === field.element) {
              return (
                <SelectField
                  name={field.name}
                  divclass={field.divclass}
                  grpmd={field.grpmd}
                  label={field.label}
                  ref={field.ref}
                  required={field.required}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  labelClass={field.labelClass}
                  values={field.values}
                  key={`${field.element}~${index}`}
                  handlechange={handlechange}
                  componentprops={props}
                  //selectedValue={selectedOptions}
                  errorMsg={field.errorMsg}
                  showErrorMsg={true}
                  isError={selectError}
                //isError= {Object.keys(selectError).length > 0 ? (selectError[field.name] ? '' : true) : ''}
                  optionWithLabel={field?.optionWithLabel}
                />
              );
            }
            if ("textarea" === field.element) {
              return (
                <>

                  <TextAreaField
                    name={field.name}
                    divclass={field.divclass}
                    grpmd={field.grpmd}
                    label={field.label}
                    ref={field.ref}
                    rows={field.rows}
                    fieldClass={field.class}
                    labelClass={field.labelClass}
                    placeholder={field.placeholder}
                    required={field.required}
                    key={`${field.element}~${index}`}
                    handlechange={handlechange}
                    errorMsg={field.errorMsg}
                    showErrorMsg={true}
                  />
                </>
              );
            }
            if ("checkbox" === field.element) {
              return (
                <CheckboxField
                  name={field.name}
                  divclass={field.divclass}
                  ref={field.ref}
                  value={field.value}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={handlechange}
                />
              );
            }
            if ("radio" === field.element) {
              return (
                <RadioboxField
                  name={field.name}
                  divclass={field.divclass}
                  ref={field.ref}
                  values={field.values}
                  fieldClass={field.class}
                  placeholder={field.placeholder}
                  required={field.required}
                  key={`${field.name}~${index}`}
                  handlechange={handlechange}
                />
              );
            }
            if ("html" === field.element) {
              return (
                <HtmlBox
                  text={field.text}
                  fieldClass={field.class}
                  key={`${field.element}~${index}`}
                />
              );
            }
            if ("captcha" === field.element) {
              return (
                <ReCaptchaBox
                  fieldClass={field.class}
                  captRef={field.captchaRef}
                  key={`${field.element}~${index}`}
                  handleonVerify={handleonVerify}
                />
              );
            }
            if ("button" === field.element) {
              return (
                <>

                  <ButtonField
                    name={field.name}
                    fieldClass={field.class}
                    type={field.type}
                    value={isSubmitting ? "Submitting..." : field.value}
                    key={`${field.element}~${index}`}
                    grpmd={field.grpmd}
                    customClass={field.customClass}
                    disable={isSubmitting}
                    iconElement={isSubmitting ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mr-2" /> : null}
                  />

                </>
              );
            }
          })
          }
        </Row>
      </Form>


    </div>
  );
}


const ContactFormPage = (props) => (
  <ContactForm {...props} />

)

export default ContactFormPage